<template>
	<div>
		<v-layout row wrap align-center>
			<v-flex xs12 text-xs-left mb-4>
				<v-btn-toggle v-model="channel" class="form-button">
					<v-btn
						v-for="channelType in channels"
						:key="channelType.id"
						flat
						:disabled="channel === channelType.id"
						:value="channelType.id"
						:class="{ 'btn--active' : channel === channelType.id }">
						{{ channelType.name }}
					</v-btn>
				</v-btn-toggle>
			</v-flex>
			<v-flex xs12>
				<v-divider class="divider-form"></v-divider>
			</v-flex>
			<v-flex xs12>
				<v-layout row wrap align-center>
					<v-flex xs6>
						<p class="title-form">Datos de reserva</p>
					</v-flex>
					<v-flex xs6 text-xs-right>
						<v-chip class="white--text">Cliente Vip</v-chip>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12>
				<v-layout row wrap align-center justify-center>
					<v-flex xs3>
						<v-subheader class="pl-0">Fecha de creación</v-subheader>
						<v-menu
							lazy
							v-model="menuCreation"
							transition="scale-transition"
							offset-y
							full-width
							class="menu-date-picker menu-form"
							max-width="290px">
							<v-text-field
								slot="activator"
								label="Fecha de creación"
								v-model="dateCreation"
								append-icon="event"
								single-line
								hide-details
								readonly
							></v-text-field>
							<v-date-picker
								v-model="dateCreation"
								locale="es-PE"
								:date-format="changeFormatDate"
								:formatted-value="formatted"
								no-title
								scrollable>
							</v-date-picker>
						</v-menu>
					</v-flex>
					<v-flex xs3>
						<v-subheader class="pl-0">Fecha de ingreso</v-subheader>
						<v-menu
							lazy
							v-model="menuEnter"
							transition="scale-transition"
							offset-y
							full-width
							class="menu-date-picker menu-form"
							max-width="290px">
							<v-text-field
								slot="activator"
								label="Fecha de ingreso"
								v-model="dateEnter"
								append-icon="event"
								single-line
								hide-details
								readonly
							></v-text-field>
							<v-date-picker
								v-model="dateEnter"
								locale="es-PE"
								:date-format="changeFormatDate"
								:formatted-value="formatted"
								v-on:input="validDate"
								no-title
								scrollable>
							</v-date-picker>
						</v-menu>
					</v-flex>
					<v-flex xs3>
						<v-subheader class="pl-0">Fecha de salida</v-subheader>
						<v-menu
							lazy
							v-model="menuOut"
							transition="scale-transition"
							offset-y
							full-width
							class="menu-date-picker menu-form"
							max-width="290px">
							<v-text-field
								slot="activator"
								label="Fecha de salida"
								v-model="dateOut"
								append-icon="event"
								single-line
								hide-details
								readonly
							></v-text-field>
							<v-date-picker
								v-model="dateOut"
								locale="es-PE"
								:date-format="changeFormatDate"
								:formatted-value="formatted"
								:allowed-dates="allowedDatesOut"
								no-title
								scrollable>
							</v-date-picker>
						</v-menu>
					</v-flex>
					<v-flex xs3>
						<v-subheader class="pl-0">Cantidad de noches</v-subheader>
						<v-text-field
							type="text"
							class="input-border-inset"
							readonly
							v-model="bookingQuantityNights">
						</v-text-field>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 mt-4>
				<v-divider class="divider-form"></v-divider>
			</v-flex>
			<v-flex xs12>
				<p class="title-form">Completa los datos</p>
			</v-flex>
			<v-flex xs12
				v-for="(model, indexModel) in guests"
				:key="indexModel">
				<v-layout row wrap align-center text-xs-left mb-3>
					<v-flex xs12 v-show="guests.length > 1">
						Persona {{ indexModel + 1 }}
					</v-flex>
				</v-layout>
				<v-layout row wrap align-center text-xs-left mb-3>
					<v-flex xs3>
						<label class="label-form">Tipo de Habitación</label>
						<v-select
							class="filter-select"
							:items="roomsType"
							item-text="name"
							item-value="id"
							v-model="model.roomType"
							hide-details
							label="Standart"
							single-line
							bottom>
						</v-select>
					</v-flex>
					<v-flex xs3>
						<label class="label-form">Nº de Habitación</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							placeholder="101"
							v-model="model.room">
						</v-text-field>
					</v-flex>
				</v-layout>
				<v-layout row wrap align-center text-xs-left mb-3>
					<v-flex xs3>
						<label class="label-form">Nombres</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							placeholder="Completos"
							v-model="model.name">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
						<label class="label-form">Apellidos</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							placeholder="Completos"
							v-model="model.lastname">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
						<label class="label-form">Fecha de nacimiento</label>
						<v-menu
							lazy
							v-model="model.menuBirthDate"
							transition="scale-transition"
							offset-y
							full-width
							class="menu-date-picker"
							max-width="290px"
							v-on:input="changeIcon">
							<v-text-field
								slot="activator"
								label="Fecha de nacimiento"
								v-model="model.birthDate"
								:append-icon="arrowIconBirth"
								:append-icon-cb="toggleIconBirthDate"
								single-line
								hide-details
								readonly
							></v-text-field>
							<v-date-picker
								v-model="model.birthDate"
								locale="es-PE"
								:date-format="changeFormatDate"
								:formatted-value="formatted"
								no-title
								scrollable>
							</v-date-picker>
						</v-menu>
					</v-flex>
					<v-flex xs3>
						<label class="label-form">País</label>
						<v-select
							autocomplete
							class="filter-select"
							:items="countries"
							item-text="name"
							item-value="id"
							v-model="model.country"
							hide-details
							single-line
							bottom>
						</v-select>
					</v-flex>
				</v-layout>
				<v-layout row wrap align-center text-xs-left mb-3>
					<v-flex xs3>
						<label class="label-form">Género</label>
						<v-select
							class="filter-select"
							item-text="value"
							item-value="id"
							:items="genders"
							v-model="model.gender"
							hide-details
							single-line
							bottom>
						</v-select>
					</v-flex>
					<v-flex xs3>
						<label class="label-form">Estado civil</label>
						<v-select
							class="filter-select"
							item-text="value"
							item-value="id"
							:items="civilStatus"
							v-model="model.civilState"
							hide-details
							single-line
							bottom>
						</v-select>
					</v-flex>
					<v-flex xs3>
						<label class="label-form">Correo electrónico</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							placeholder="nombre@mail.com"
							v-model="model.email">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
						<label class="label-form">Tipo de identificación</label>
						<v-select
							class="filter-select filter-select-indicator"
							item-text="value"
							item-value="id"
							:items="typeDocuments"
							v-model="model.typeDocument"
							hide-details
							single-line
							bottom>
						</v-select>
						<v-text-field
							type="number"
							class="input-border-inset input-form-select"
							v-model="model.document">
						</v-text-field>
					</v-flex>
				</v-layout>
				<v-layout row wrap align-center text-xs-left mb-3>
					<v-flex xs3>
						<label class="label-form">Niños</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							readonly
							placeholder="0"
							v-model="model.children">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
						<label class="label-form">Bebés</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							readonly
							placeholder="0"
							v-model="model.babys">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
						<label class="label-form">Teléfono</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							readonly
							v-model="model.phone">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
						<label class="label-form">Nº de Tarjeta Vip</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							readonly
							v-model="model.vipCard">
						</v-text-field>
					</v-flex>
				</v-layout>
				<v-layout row wrap align-center text-xs-left mb-3>
					<v-flex xs3 v-show="channel === 2">
						<label class="label-form">Operador</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							readonly
							v-model="model.operator">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
						<label class="label-form">Vendedor</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							readonly
							v-model="model.seller">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
						<label class="label-form">Modo de captura</label>
						<v-select
							class="filter-select"
							:items="media"
							v-model="model.mediaSelected"
							hide-details
							single-line
							bottom>
						</v-select>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12>
				<v-layout row wrap align-center>
					<v-flex xs3>
						<button-create
							btn-function
							text="Agregar a otra persona"
							class="justify-center"
							@function-click="addGuest">
						</button-create>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 mt-4>
				<v-divider class="divider-form"></v-divider>
			</v-flex>
			<v-flex xs12>
				<v-layout row wrap align-center>
					<v-flex xs2>
						<v-switch
							:label="dataModel[channel].title" 
							v-model="dataModel[channel].active"
							color="success"
							class="input-switch"
							hide-details>
						</v-switch>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12>
				<v-layout row wrap align-center text-xs-left
					:class="{ 'disabled-block' : !dataModel[channel].active }">
					<v-flex xs3>
						<label class="label-form">Nombres</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							placeholder="Nombres"
							:disabled="!dataModel[channel].active"
							v-model="dataModel[channel].name">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
						<label class="label-form">Apellidos</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							placeholder="Apellidos"
							:disabled="!dataModel[channel].active"
							v-model="dataModel[channel].lastname">
						</v-text-field>
					</v-flex>
					<v-flex xs3 v-show="channel === 2">
						<label class="label-form">Nº Registro Fiscal</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							placeholder="Nº de RUC, RUT, IVA, VAT"
							:disabled="!dataModel[channel].active"
							v-model="dataModel[channel].documentNumber">
						</v-text-field>
					</v-flex>
					<v-flex xs3 v-show="channel === 3">
						<label class="label-form">Nº de file</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							placeholder="Nº de Voucher"
							:disabled="!dataModel[channel].active"
							v-model="dataModel[channel].fileNumber">
						</v-text-field>
					</v-flex>
					<v-flex xs3 v-show="channel === 4">
						<label class="label-form">Nº de Voucher</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							placeholder="Nº de Voucher"
							:disabled="!dataModel[channel].active"
							v-model="dataModel[channel].voucher">
						</v-text-field>
					</v-flex>
					<v-flex xs3 v-show="channel === 5">
						<label class="label-form">Nº de Reserva</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							placeholder="Nº de Reserva"
							:disabled="!dataModel[channel].active"
							v-model="dataModel[channel].bookingNumber">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
						<label class="label-form">Correo electrónico</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							placeholder="nombre@mail.com"
							:disabled="!dataModel[channel].active"
							v-model="dataModel[channel].email">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
						<label class="label-form">Teléfono</label>
						<v-text-field
							type="number"
							class="input-border-inset input-form-prefix"
							prefix="+51"
							:disabled="!dataModel[channel].active"
							v-model="dataModel[channel].phone">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
						<label class="label-form">País</label>
						<v-select
							autocomplete
							class="filter-select filter-select-main"
							:items="countries"
							item-text="name"
							item-value="id"
							v-model="dataModel[channel].country"
							hide-details
							:disabled="!dataModel[channel].active"
							single-line
							bottom>
						</v-select>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 mt-4>
				<v-divider class="divider-form"></v-divider>
			</v-flex>
			<v-flex xs12>
				<v-layout row wrap align-center>
					<v-flex xs3
						mb-3
						v-for="additional in additionals"
						:key="additional.id">
						<v-checkbox
							class="input-checkbox"
							:label="additional.name"
							v-model="selectedAdditionals">
						</v-checkbox>
						<v-text-field
							type="text"
							class="input-border-inset"
							readonly
							:value="additional.price | round">
						</v-text-field>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12>
				<v-layout row wrap justify-end>
					<v-flex xs3 text-xs-left>
						<label class="label-form">Total</label>
						<v-text-field
							type="text"
							class="input-regular"
							readonly
							hide-details
							prefix="$"
							:value="totalAmount | round">
						</v-text-field>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 text-xs-left mt-3>
				<label class="label-form">Observaciones</label>
				<v-text-field
					class="input-textarea mt-1"
					no-resize
					multi-line
					:rows="3"
					textarea
				></v-text-field>
			</v-flex>
			<v-flex xs12>
				<v-layout row wrap align-center justify-end>
					<v-flex xs3>
						<v-btn
							type="submit"
							class="btn-save btn-save-form mt-3">
							Aceptar
						</v-btn>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import { addDays, differenceInDays, format, isAfter } from 'date-fns';
	import mixin from '@/shared/mixins';
	import helper from '@/shared/helper';
	import ButtonCreate from '@/components/shared/ButtonCreate';
	import { round } from '@/shared/filters';

	const helperMethods = helper.methods;

	function created() {
		this.loadResources();
		this.loadData();
	}

	function addGuest() {
		const model = {
			additionals: [],
			babys: 0,
			birthDate: null,
			children: 0,
			civilState: 2,
			country: 'Perú',
			document: '',
			email: '',
			gender: 1,
			lastname: '',
			mediaSelected: 'E-mail',
			menuBirthDate: false,
			name: '',
			operator: '',
			phone: '',
			room: null,
			roomType: null,
			seller: '',
			typeDocument: 2,
			vipCard: '',
		};
		this.guests.push(model);
	}

	function allowedDatesOut(date) {
		const newDay = new Date(this.dateEnter).getDate() + 2;
		const newMonth = new Date(this.dateEnter).getMonth() + 1;
		const newYear = new Date(this.dateEnter).getFullYear();
		const newDate = `${newYear}-${newMonth}-${newDay}`;
		return isAfter(new Date(date), new Date(newDate));
	}

	function arrowIconBirth() {
		const arrow = this.onChange ? 'arrow_drop_up' : 'arrow_drop_down';
		return arrow;
	}

	function bookingQuantityNights() {
		return differenceInDays(new Date(this.dateOut), new Date(this.dateEnter));
	}

	function changeFormatDate(value) {
		return new Date(value).toISOString().substr(0, 10);
	}

	function changeIcon(result) {
		this.onChange = result;
	}

	async function loadData() {
		const response = await this.$http.get(`${process.env.PMS_URL}/bookings/${this.bookingCode}`);
		this.model = response.data.data;
	}

	async function loadResources() {
		const user = helperMethods.getUser();
		const request = [
			this.$http.get(`${process.env.MIDDLEWARE_URL}/poll/datacompany/${user.company_id}`),
			this.$http.get(`${process.env.PMS_URL}/channels`),
			this.$http.get(`${process.env.PMS_URL}/roomtype/${this.hotelId}`),
		];
		const responses = await Promise.all(request);
		this.countries = responses[0].data.data.countries;
		this.channels = responses[1].data.data;
		this.roomsType = responses[2].data.data;
		responses[1].data.data.forEach((channel) => {
			this.dataModel[channel.id].country = `${process.env.DEFAULT_COUNTRY_ID}`;
		});
		this.guests = this.guests.map((guest) => {
			const newGuest = Object.assign({}, guest);
			newGuest.country = `${process.env.DEFAULT_COUNTRY_ID}`;
			return newGuest;
		});
	}

	function toggleIconBirthDate() {
		this.onChange = !this.modal.birthDate;
	}

	function totalAmount() {
		return this.selectedAdditionals.reduce((acum, add) => acum + add.price, 0);
	}

	function validDate(date) {
		this.dateOut = differenceInDays(new Date(this.dateOut), new Date(date)) < 0 ?
			format(addDays(new Date(date), 2), 'YYYY-MM-DD') : this.dateOut;
	}

	function data() {
		return {
			additionals: [
				{ id: 1, name: 'Alojamiento', price: 45 },
				{ id: 2, name: 'AA BN', price: 45 },
				{ id: 3, name: 'B.A', price: 45 },
				{ id: 4, name: 'Lavandería', price: 45 },
				{ id: 5, name: 'Traslados', price: 45 },
				{ id: 6, name: 'QP Store', price: 45 },
				{ id: 7, name: 'Frigobar', price: 45 },
				{ id: 8, name: 'Telefonía', price: 45 },
			],
			channel: 1,
			channels: [],
			civilStatus: [
				{ id: 1, value: 'Soltero' },
				{ id: 2, value: 'Casado' },
				{ id: 3, value: 'Viudo' },
				{ id: 4, value: 'Divorciado' },
			],
			countries: [],
			dataModel: {
				1: {
					active: true,
					country: 0,
					email: '',
					lastname: '',
					name: '',
					phone: '',
					title: 'Datos de Walk-in',
				},
				2: {
					active: true,
					country: 0,
					documentNumber: null,
					email: '',
					lastname: '',
					name: '',
					phone: '',
					title: 'Datos de Empresa',
				},
				3: {
					active: true,
					country: 0,
					email: '',
					fileNumber: '',
					lastname: '',
					name: '',
					phone: '',
					title: 'Datos de Agencia',
				},
				4: {
					active: true,
					country: 0,
					email: '',
					lastname: '',
					name: '',
					phone: '',
					title: 'Datos de OTA',
					voucher: '',
				},
				5: {
					active: true,
					bookingNumber: '',
					country: 0,
					email: '',
					lastname: '',
					name: '',
					phone: '',
					title: 'Datos de Página Web',
				},
			},
			dateCreation: format(new Date(), 'YYYY-MM-DD'),
			dateEnter: format(new Date(), 'YYYY-MM-DD'),
			dateOut: format(addDays(new Date(), 1), 'YYYY-MM-DD'),
			formatted: null,
			genders: [
				{ id: 1, value: 'Varón' },
				{ id: 2, value: 'Mujer' },
			],
			guests: [
				{
					additionals: [],
					babys: 0,
					birthDate: null,
					children: 0,
					civilState: 2,
					country: 0,
					document: '',
					email: '',
					gender: 1,
					lastname: '',
					mediaSelected: 'E-mail',
					menuBirthDate: false,
					name: '',
					operator: '',
					phone: '',
					room: null,
					roomType: null,
					seller: '',
					typeDocument: 2,
					vipCard: '',
				},
			],
			media: ['E-mail'],
			menuCreation: false,
			menuEnter: false,
			menuOut: false,
			model: {},
			onChange: false,
			roomsType: [],
			selectedAdditionals: [],
			typeDocuments: [
				{ id: 1, value: 'DNI' },
				{ id: 2, value: 'Pasaporte' },
			],
		};
	}

	export default {
		name: 'check-in-form',
		components: {
			ButtonCreate,
		},
		computed: {
			arrowIconBirth,
			bookingQuantityNights,
			totalAmount,
		},
		created,
		data,
		filters: {
			round,
		},
		methods: {
			addGuest,
			allowedDatesOut,
			changeFormatDate,
			changeIcon,
			loadData,
			loadResources,
			toggleIconBirthDate,
			validDate,
		},
		mixins: mixin,
		props: ['bookingCode', 'hotelId'],
	};
</script>

<style lang="scss" scoped>
	.form-button {
		background-color: transparent;
		box-shadow: none;

		.btn {
			background-color: map-get($colors, button-form) !important;
			border-radius: 0px;
			box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .18) !important;
			color: white;
			height: 40px;
			margin-right: 14px;
			min-width: 98px;
			opacity: 1;

			&--active {
				background-color: map-get($colors, default-skyblue) !important;
			}
		}
	}

	.divider-form {
		margin: 0 -20px;
		width: 100vw;
	}

	.chip {
		background-color: map-get($colors, default-skyblue);
		border-radius: 0px;
		box-shadow: none !important;
		font-size: 10px;
		height: 18px;
		line-height: 18px;
		justify-content: center;
		padding: 0px;
		text-transform: uppercase;
		width: 65px;
	}

	.disabled-block {
		opacity: .5;
	}

	.btn-save-form {
		max-width: 100% !important;
	}
</style>


// WEBPACK FOOTER //
// Form.vue?2f09a7a3